import { TUser } from 'types/user';

export const ANONYM_USER: TUser = { isAuthenticated: false };
